<template>
  <div class="flex items-center">
    <img 
      v-if="iconOnly"
      src="/shardfavicon.png" 
      alt="Shardfy Logo" 
      :class="logoClasses"
    />
    <img 
      v-else
      src="/shardfy-name.png" 
      alt="Shardfy" 
      :class="fullLogoClasses"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  iconOnly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  iconOnly: false
})

// Classes para o ícone apenas (quando iconOnly = true)
const logoClasses = computed(() => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-10 w-10',
    xl: 'h-12 w-12'
  }
  
  return sizeClasses[props.size]
})

// Classes para o logo completo com nome (quando iconOnly = false)
const fullLogoClasses = computed(() => {
  const sizeClasses = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-10',
    xl: 'h-12'
  }
  
  return `${sizeClasses[props.size]} w-auto`
})
</script>